import { render } from "./car_repair_type.vue?vue&type=template&id=205472a0"
import script from "./car_repair_type.vue?vue&type=script&lang=js"
export * from "./car_repair_type.vue?vue&type=script&lang=js"

import "./car_repair_type.vue?vue&type=style&index=0&id=205472a0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__